import React from 'react';
import './Header.css';
import logo from '../assets/logo.webp';

function Header({ userInfo }) {
  const authProvider = window.location.hostname === "localhost" ? "local" : "aadb2c";
  const loginUrl = `/.auth/login/${authProvider}`;
  const logoutUrl = `/.auth/logout?post_logout_redirect_uri=/`;

  // Clear project data cache on logout
  const handleLogout = (e) => {
    if (window.ApiComponent && typeof window.ApiComponent.clearCache === 'function') {
      window.ApiComponent.clearCache();
    } else {
      // Fallback: manually clear cache keys
      localStorage.removeItem('apiComponentDataCache');
      localStorage.removeItem('apiComponentDataCacheTime');
      localStorage.removeItem('apiComponentDataCacheEmail');
      sessionStorage.removeItem('apiComponentViewAsEmail');
      localStorage.setItem('signedOut', 'true');
      setTimeout(() => localStorage.removeItem('signedOut'), 100);
    }
    // Proceed to logout
    window.location.href = logoutUrl;
    e.preventDefault();
  };
  return (
    <header className="milrose-header">
      <div className="milrose-header-inner" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <a href="/" tabIndex={0} aria-label="Home" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src={logo} alt="Milrose Logo" className="milrose-logo" />
          </a>
          <span className="milrose-title">Milrose Project Portal</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {!userInfo && (
            <div className="milrose-auth-btn">
              <a href={loginUrl} className="btn btn-info btn-sm" role="button">Sign In</a>
            </div>
          )}
          {userInfo && (
            <div className="milrose-auth-btn" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div className="milrose-welcome">Welcome, {userInfo.emails || userInfo.userDetails}</div>
              <a href={logoutUrl} className="btn btn-dark btn-sm" role="button" onClick={handleLogout}>Sign Out</a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
